import { Step } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { StepConnectorStyled, StepLabelStyled, StepperStyled } from 'v3/shared/components/HorizontalStepper/styles';
import { HorizontalStepperProps } from 'v3/shared/components/HorizontalStepper/types';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';

export const HorizontalStepper = ({ completedStepIndex, activeStepIndex, steps }: HorizontalStepperProps) => {
  const theme = useTheme();
  const { isMobile } = useBreakpoints();

  return (
    <StepperStyled
      orientation={isMobile ? 'vertical' : 'horizontal'}
      connector={<StepConnectorStyled />}
      activeStep={activeStepIndex}
    >
      {steps.map((label, index) => (
        <Step completed={completedStepIndex === index} key={label}>
          <StepLabelStyled>
            <SubtitleMedium color={theme.palette.common.white}>{label}</SubtitleMedium>
          </StepLabelStyled>
        </Step>
      ))}
    </StepperStyled>
  );
};
